var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 697.79 695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.9,0C157,0,0,156.65,0,349.59c0,174.45,127.7,319.24,294.47,345.41v-244.23h-88.62v-101.18h88.62v-77.11c0-87.57,51.99-135.72,131.88-135.72,38.03,0,77.8,6.63,77.8,6.63v86.18h-43.96c-43.26,0-56.87,26.86-56.87,54.43v65.59h96.99l-15.7,101.18h-81.29v244.23c82.21-12.99,157.08-54.93,211.08-118.28,54-63.34,83.58-143.9,83.39-227.13C697.79,156.65,540.79,0,348.9,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.95c498b2779bb0fdf030ca376b266d29.svg";
export { ForwardRef as ReactComponent };